"use client"

import React from 'react';
import Script from 'next/script'
import { useEffect, useRef } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

export default function FontplusLoader() {
    const isFirstRender = useRef(true);
    const pathname = usePathname()
    const searchParams = useSearchParams()

    // URLが変更された際に実行される処理
    // isFirstRenderを利用して初回レンダー時は処理しない
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        } else if(FONTPLUS) {
            if (!(/iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent))) {
                document.querySelectorAll('.font-Time').forEach((element: any) => {
                    element.classList.add('isAndroid');
                });
            }
            FONTPLUS.reload(false);

            // FONTPLUS.reload(true);
            // FONTPLUS.async();
            // FONTPLUS.start();
        }
    }, [pathname, searchParams])

    return (
        <Script
            src="https://webfont.fontplus.jp/accessor/script/fontplus.js?forB47Q3OXY%3D&box=qJYPUlMU5Pk%3D&aa=1&ab=2"
            strategy="afterInteractive"
            onLoad={() => {
                if (FONTPLUS) {
                    FONTPLUS.reload(true);
                }
            }}
        />
    )
}